import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

/** Upload → preview → destination → review → deliver flow. */
const UploadDeliveryPage = lazy(() => import('~/features/integrations/pages/upload-delivery-page'));

/**
 * `uploadId` + `groupId` identify an in-flight delivery, so the flow can be resumed from the
 * deliveries list (or a refresh) instead of only living in component state. Both are needed:
 * delivery status is keyed by the upload, while the filter catalog and row preview are keyed
 * by its group. Absent → a fresh upload starts at step 1.
 */
const searchSchema = z.object({
  uploadId: z.string().optional(),
  groupId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/upload-delivery/single')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <UploadDeliveryPage />
    </Suspense>
  );
}
